import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { psiTokens } from '../../theme/psiTheme';

const modalities = [
  {
    title: 'On-site',
    description:
      "Training and intervention directly at the client's facilities, working with real processes, equipment, and people.",
  },
  {
    title: 'Online',
    description:
      'Live sessions via digital platforms. Full scheduling flexibility and unlimited geographic reach.',
  },
  {
    title: 'Hybrid',
    description:
      'A combination of on-site and virtual sessions, tailored to the pace and needs of the team.',
  },
];

export default function Modalities() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        backgroundColor: psiTokens.background.secondary,
        py: isMobile ? 6 : 8,
      }}
    >
      <Container maxWidth="xl">
        {/* Section header */}
        <Box sx={{ mb: 5 }}>
          {/* Accent line */}
          <Box
            sx={{
              width: '40px',
              height: '3px',
              background: `linear-gradient(90deg, ${psiTokens.primary.dark}, ${psiTokens.primary.light})`,
              borderRadius: '2px',
              mb: 2,
            }}
          />

          <Typography
            sx={{
              fontSize: '11px',
              fontWeight: 600,
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              color: psiTokens.primary.light,
              marginBottom: 2,
            }}
          >
            How & Where
          </Typography>

          <Typography
            variant="h2"
            sx={{
              color: psiTokens.text.primary,
              marginBottom: 2,
              fontWeight: 700,
            }}
          >
            PSI goes where there are problems to solve.
          </Typography>

          <Typography
            sx={{
              fontSize: '15px',
              fontWeight: 400,
              color: psiTokens.text.tertiary,
              lineHeight: 1.8,
              marginBottom: 4,
              maxWidth: '700px',
            }}
          >
            Every engagement adapts to the client's context regardless of industry, team size, or
            location.
          </Typography>
        </Box>

        {/* Modalities Grid */}
        <Grid container spacing={3}>
          {modalities.map((modality, idx) => (
            <Grid item xs={12} sm={6} md={4} key={idx}>
              <Card
                sx={{
                  height: '100%',
                  backgroundColor: psiTokens.background.primary,
                  borderRadius: '12px',
                  border: `1px solid ${psiTokens.border}`,
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      color: psiTokens.primary.dark,
                      marginBottom: 2,
                      fontWeight: 700,
                    }}
                  >
                    {modality.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '13px',
                      fontWeight: 400,
                      color: psiTokens.text.secondary,
                      lineHeight: 1.7,
                    }}
                  >
                    {modality.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
